import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import LanguageSelect from 'src/components/common/LanguageSelect';
import { IStateCollection } from 'src/entity/StateEntity';

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch: Dispatch<IStateCollection>) => {
  return {
    // setIsDomestic: (isDomestic: boolean) => dispatch(Actions.setIsDomestic(isDomestic)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSelect);



// WEBPACK FOOTER //
// ./src/containers/LanguageSelect.ts